// client/src/services/noteService.js
import { getApiConfig } from '../config/markets.js';

const API_URL = getApiConfig().apiUrl;

export async function listNotes(conversationId) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No se encontró token de autenticación');
  }
  const res = await fetch(`${API_URL}/conversations/${conversationId}/notes`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("Error cargando notas");
  return res.json();
}

export async function createNote(conversationId, content) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No se encontró token de autenticación');
  }
  const res = await fetch(`${API_URL}/conversations/${conversationId}/notes`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ content }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || "Error guardando nota");
  }
  return res.json();
}
